/*
 * @Author: your name
 * @Date: 2020-06-11 16:24:48
 * @LastEditTime: 2020-06-23 10:43:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\i18n\lang\it.js
 */
module.exports = {
    buyRegister: {
        mainName: 'Per favore inserisci il tuo cognome',//姓
        firstName: 'Per favore immettere il proprio Nome',//名
        email: 'Inserisci il tuo indirizzo email.',//邮箱
        confemail: 'Conferma il tuo indirizzo email.',//确认邮箱
        iphone: 'Inserisci il tuo numero di cellulare.',//电话号码
        num: 'Per favore immetti il tuo numero di telefono.',//座机号码
        pwd: 'Per favore inserire una password.',//电话号码
        confpwd: 'Per favore conferma la tua password.',//密码
        errorEmail: 'Si prega di controllare la tua email.',//输入一样的密码
        errorPwd: 'Per favore controlla la tua password.',//输入一样的密码
        emailType: 'Controlla il formato della tua email',//输入一样的邮箱地址
        pwdType: 'Controlla il formato della tua password',//密码格式不正确
        webSite: "Inserisci l'indirizzo del tuo sito web",//网站地址
        confwebSite: 'Controlla il formato del tuo sito web',//网站地址不正确
        country: 'Selezionare il proprio paese',//国家
        intra: 'Inserisci il tuo numero di partita IVA aziendale',//税号

        word1: 'Si prega di inserire un numero civico',//街道号码
        word2: 'Inserisci un indirizzo',//地址
        word3: 'Inserisci una città.',//城市
        word4: 'Inserisci un numero di telefono.',//电话号码
        word5: 'Immettere un nome di contatto',//联系人姓
        word6: 'Inserisci un codice postale',//邮编
        word7: 'Si prega di inserire un numero civico',//请输入街道号码
        word8: 'Inserisci un indirizzo.',//请输入地址
        word9: 'Inserisci una città.',//请输入城市
        word10: 'Inserisci un numero di telefono.',//请输入联系电话
        word11: 'Immettere un nome di contatto',//请输入联系人姓
        word12: 'Inserisci un codice postale',//请输入邮编
        word13: 'Immettere un nome di contatto',//请输入姓
        word14: 'Seleziona una lingua predefinita',//请选择默认语言
        word15: 'Seleziona la tua area di attività.',//请选择经营范围
        word16: "Si prega di accettare i termini di utilizzo e l'informativa sulla privacy.",//请同意使用条款
        word17: 'english address must input eori.',//英国地址必须填写eori号码
    },
    sellRegister: {
        sell1: 'Per favore digita il nome della tua azienda',//请输入企业名称
        sell2: 'Per favore inserisci il tuo cognome',//请输入商家姓
        sell3: 'Per favore immettere il proprio Nome',//请输入商家名
        sell4: 'Inserisci il tuo numero di partita IVA aziendale',//请输入税号
        sell5: 'Inserisci il nome del negozio',//请输入店铺名称
        sell6: 'Questo indirizzo e-mail è già in uso',//您的邮箱地址已注册
        sell7: 'Si prega di inserire un numero civico',//请输入街道号码
        sell8: 'Inserisci una città',//请输入商家城市
        sell9: 'Inserisci una città',//请输入商家城市
        sell10: 'Inserisci un indirizzo',//请输入地址
        sell11: 'Inserisci un codice postale',//请输入邮编
        sell12: 'Carica una prova di attività',//请输入税号
        sell13: 'Indicare il numero di banca commerciale',//请输入商家银行号
        sell14: 'Si prega di indicare il numero di telefono',//请输入商家银行号
        sell15: "Carica l'ID del gestore",//请上传商家身份证件
        sell16: 'Inserisci i tuoi marchi',//请添加商家品牌
        sell17: 'Inserisci le tue categorie',//请选择商家产品目录
        sell18: "Inserisci l'importo minimo dell'ordine desiderato",//请填写最低订单要求
        sell19: 'Per favore inserisci un numero',//请输入有效数字
        sell20: 'Seleziona il tuo campo di attività'//请选择商家营业范围
    },
    account: {
        word1: "disconnettersi",//登出
        word2: "L'indirizzo e-mail non deve essere vuoto", //email地址不能为空
        word3: "Le due e-mail sono diverse",//两个邮箱地址不一致
        word4: "Iscriviti alla newsletter di efashion paris",//是否订阅邮件
        word5: "Accetto di ricevere notifiche sull'applicazione",//是否接收手机应用的同志
        word6: "Accetto di ricevere sms",//是否接收订单更新的短信通知
    },
    seller_marques: {
        word1: "il marchio è stato aggiunto ai preferiti.",//添加收藏成功 商家
        word2: "il marchio è stato rimosso dai preferiti.",//取消收藏成功 商家
        word3: "Effettua il login per eseguire questa azione.",//请先登录 再进行这个操作
    },
    product_detail: {
        word1: "Il prodotto è stato aggiunto al tuo carrello",//产品已经添加到购物车
        word2: "La quantità minima d'ordine è ",//最低订购数量为
        word3: "Colori",//颜色
        word4: "Confezioni",//包
        word5: "Quantità",//数量
        word6: "Totale",//总数
        word7: "Quantité ou montant acheté incorrect",//购买数量或者金额有误
    },
    goods_list: {
        couleurs:'Colori',
        melangees:'Colori mescolati',
        tailles:'Taglie alle scelte',
    },
    favor_articles: {
        word1: "Aggiungi ai preferiti con successo!",//添加收藏成功
        word2: "Rimuovi dai preferiti con successo!",//取消收藏成功
        word3: "Operazione fallita, riprova.",//收藏操作失败
    },
    common: {
        yes: 'sì',//是
        no: 'No'//否
    },
    moncompte_articles: {
        word1: 'Uno o più articoli presentano difetti ',
        word2: 'Oggetti mancanti',
        word3: 'Ho ricevuto uno o più articoli che non corrispondono al mio ordine',
        word4: 'Ciao, ho "numero di articoli danneggiati" nel mio ordine, troverai allegate le foto come prova (scarica le foto). Per favore aiutami con la mia richiesta.',
        word5: 'Ciao, ho appena ricevuto il mio ordine ma mancano alcuni articoli: "completo da parte dell\'acquirente". Si prega di informare il fornitore e di ricontattarmi.',
        word6: 'Ciao, ho appena ricevuto il mio ordine e "dettaglia il problema con precisione, riferimento, colore, taglia errati". Si prega di informare il fornitore e di ricontattarmi.',
        word7: 'altro',
    },
    topMenuDesc: {
        'Accessoires': 'Accessori',
        'Marques': 'Marche',
        'Nouveautés': 'Notizie',
        'Outlet': 'negozio',
        'Vêtements': 'Vestiti',
        'decouvrir': 'Scoprire',
        "AJOURD HUI": "NUOVA OGGI",
        'CETTE SEMAINE': 'NUOVA SETTIMANA',
        'NOUVEAUX VENDEURS': 'NUOVA VENDITORI',
        'Nouveautés Vêtements': 'Nuovo Abbigliamento',
        'Nouveautés Accessoires': 'Nuovi accessori',
        'Tendances': 'Tendenza',
    },
    topMenuOutlet: {
        word1: 'Acquisti al prezzo di acquisto',
        word2: "Più di 5 euro",
        word3: "Da 5 a 10 euro",
        word4: "Da 10 a 15 euro",
        word5: 'Acquisti a prezzo ridotto',
        word6: "0 fino al 30%",
        word7: 'Dal 30 al 50 per cento',
        word8: 'Oltre il 50%',
        word9: 'Codice di promozione',
        word10: "Uno sconto",
        word11: "Tutte le promozioni",
        word12: "Prezzo di favore",
        word13: "Promozione delle vendite",
        word14: "Vendita speciale di calzature",
        word15: "Oggetto: concessione di un aiuto a favore di un produttore di fibre sintetiche",
        word16: "Vendite ad alta velocità",
        word17: "meno",
        word18: "5€",
        word19: "meno 5€",
    },
    topMenuNoLogin: {
        'preview catalog': 'Anteprima del catalogo',
    },
    chooseCarte: {
        word1: 'eori can not empty',
        word2: 'english need eori,please add eori at address modify',
    },
    homeLogin: {
        word1: 'copiare',
    }
}
